require('./vue');
const SmoothScroll = require('smooth-scroll');
const Flickity = require('flickity');

import { MDCDataTable } from '@material/data-table';
import { MDCDrawer } from '@material/drawer';
import { MDCList } from '@material/list';
import { MDCRipple } from '@material/ripple';
import { MDCSelect } from '@material/select';
import { MDCSelectIcon } from '@material/select/icon';
import { MDCTextField } from '@material/textfield';
import { MDCTextFieldIcon } from '@material/textfield/icon';
import { MDCTopAppBar } from '@material/top-app-bar';
import { MDCLinearProgress } from '@material/linear-progress';

import { startMonitoring } from "./monitoring";

startMonitoring();

require("./bootstrap");
const version = '1.0.0';

window.onload = function() {

    /**
     * Material Components
     */

    if (document.querySelectorAll(".mdc-top-app-bar").length > 0) {
        const topAppBar = new MDCTopAppBar(
            document.querySelector(".mdc-top-app-bar")
        );
        topAppBar.setScrollTarget(document.getElementById("app"));
    }

    const selector = ".mdc-button, .mdc-icon-button, .mdc-card__primary-action";
    if (document.querySelectorAll(selector)) {
        const ripples = [].map.call(
            document.querySelectorAll(selector),
            function(el) {
                return new MDCRipple(el);
            }
        );
    }

    if (document.querySelectorAll(".mdc-select")) {
        [].map.call(document.querySelectorAll(".mdc-select"), function(el) {
            return new MDCSelect(el);
        });
    }

    let selectProvince;
    if (document.querySelector("#province-id")) {
        selectProvince = new MDCSelect(document.querySelector("#province-id"));
    }
    let selectSchool;
    if (document.querySelector("#school-id")) {
        selectSchool = new MDCSelect(document.querySelector("#school-id"));
    }

    if (selectProvince) {
        selectProvince.listen("MDCSelect:change", () => {
            document.querySelector('#id-province').value = selectProvince.value;
        });
    }
    if (selectSchool) {
        selectSchool.listen("MDCSelect:change", () => {
            document.querySelector('#id-school').value = selectSchool.value;
        });
    }

    if (document.querySelectorAll(".mdc-select__icon").length > 0) {
        [].map.call(document.querySelectorAll(".mdc-select__icon"), function(
            el
        ) {
            return new MDCSelectIcon(el);
        });
    }

    if (document.querySelectorAll(".mdc-list").length > 0) {
        [].map.call(document.querySelectorAll(".mdc-list"), function(el) {
            new MDCList(el);
        });
    }

    if (document.querySelectorAll(".mdc-data-table").length > 0) {
        [].map.call(document.querySelectorAll(".mdc-data-table"), function(el) {
            new MDCDataTable(el);
        });
    }

    if (document.querySelectorAll(".mdc-text-field").length > 0) {
        [].map.call(document.querySelectorAll(".mdc-text-field"), function(el) {
            new MDCTextField(el);
        });
    }

    if (document.querySelectorAll(".mdc-text-field-icon").length > 0) {
        [].map.call(document.querySelectorAll(".mdc-text-field-icon"), function(el) {
            new MDCTextFieldIcon(el);
        });
    }

    if (document.querySelectorAll(".mdc-linear-progress").length > 0) {
        [].map.call(document.querySelectorAll(".mdc-linear-progress"), function(el) {
            new MDCLinearProgress(el);
        });
    }

    /**
     * Smooth Scroll
     */

    new SmoothScroll('a[href*="#"]');

    if (document.querySelectorAll('.home-licenses--collapsible-btn').length > 0) {
        const scroll = new SmoothScroll();
        for (const el of document.querySelectorAll('.home-licenses--collapsible-btn')) {
            el.addEventListener('click', e => {
                let content = document.getElementsByClassName('home-licenses--collapsible-content')[0];
                if (content.style.maxHeight) content.style.maxHeight = null;
                else content.style.maxHeight = content.scrollHeight + 'px';
                if (el.classList.contains('active')) {
                    scroll.animateScroll(document.querySelector('.home #licenses'))
                }
                const buttonTexts = {
                    ca: ['Veure més', 'Veure menys'],
                    es: ['Ver más', 'Ver menos'],
                };
                const langTexts = buttonTexts[window.appLocale];
                el.lastElementChild.textContent = el.classList.contains('active') ? langTexts[0] : langTexts[1];
                el.classList.toggle('active');
            });
        }
    }

    /**
     * Flickity
     */

     if (document.querySelectorAll(".carousel-home").length > 0) {
        for (const carouselHome of document.querySelectorAll(".carousel-home")) {
            new Flickity(carouselHome, {
                adaptiveHeight: false,
                wrapAround: false,
                contain: true,
                groupCells: true,
                freeScroll:false,
                autoPlay: 3000,
                pauseAutoPlayOnHover: false
            });
            carouselHome.classList.add('loaded');
        }
    }

    if (document.querySelectorAll(".carousel").length > 0) {
        for (const carousel of document.querySelectorAll(".carousel")) {
            new Flickity(carousel, {
                adaptiveHeight: false,
                wrapAround: false,
                contain: true,
                groupCells: true,
                freeScroll:true
            });
        }
    }

    /**
     * Collapsible
     */

    for (const label of document.querySelectorAll(".lbl-toggle")) {
        label.addEventListener("keydown", e => {
            if (e.which === 32 || e.which === 13) {
                e.preventDefault();
                label.click();
            }
        });
    }

    /**
     * Header effect
     */

    var didScroll;
    var lastScrollTop = 0;
    var delta = 5;
    const headerElement = document.getElementById('navbar');

    window.addEventListener('scroll', function () {
        didScroll = true
        setInterval(function() {
            if (didScroll) {
                hasScrolled(this);
                didScroll = false;
            }
        }, 250);
    })


    function hasScrolled() {
        var st = window.scrollY;

        // En caso de que la vista sea la de buscar la autoesculea mas cercana el header no se esconde
        if(window.location.pathname.includes('autoescuelas') || window.location.pathname.includes('autoescoles')) return;

        if (Math.abs(lastScrollTop - st) <= delta && st !== 0) return;
        if(!headerElement.classList.contains('wizard-header')){
            if (st <= 0) {
                headerElement.classList.remove('nav-up');
                headerElement.classList.add('nav-down', 'on-top');
            }else if (st > lastScrollTop) {
                headerElement.classList.remove('nav-down', 'on-top');
                headerElement.classList.add('nav-up');
            } else {
                if (st === 0) {
                    headerElement.classList.remove('nav-up');
                    headerElement.classList.add('nav-down', 'on-top');
                } else if (st + window.innerHeight < document.body.offsetHeight) {
                    headerElement.classList.remove('nav-up', 'on-top');
                    headerElement.classList.add('nav-down');
                }
            }
        }
        lastScrollTop = st;
    }

    // Menu and Submenu autoescuela
    if(document.getElementById('open-autoescuela')){
        document.getElementById('open-autoescuela').addEventListener("click", () => {
            document.getElementById('menu-autoescuela').classList.add('hoverable');
        });
    }

    if(document.getElementById('close-autoescuela')){
        document.getElementById('close-autoescuela').addEventListener("click", () => {
            document.getElementById('menu-autoescuela').classList.remove('hoverable');
        });
    }
};



/**
* Set iframe-container height
*/

if (document.querySelector('.has-iframe')) {
    window.addEventListener('orientationchange', () => window.setTimeout(setIframeContainerHeight, 1000));
    setIframeContainerHeight();

    function setIframeContainerHeight() {
        var iframeContainer = document.querySelector('.iframe-container');
        var iframe = document.querySelector('iframe');
        var iframeHeight = iframe.clientHeight;
        var headerHeight = document.querySelector('header').clientHeight;
        var footerHeight = document.querySelector('footer').clientHeight;
        var calculatedHeight = window.innerHeight - headerHeight - footerHeight - 70;
        if (window.innerHeight > calculatedHeight && calculatedHeight >= iframeHeight) {
            iframeContainer.style.height = calculatedHeight + 'px';
        } else {
            iframeContainer.style.height = 'auto';
        }
        iframe.classList.remove('invisible');
    }

}
